import Assembleia from "app/models/assembleia/assembleia.model";

export abstract class AbAssembleiaValidation {
  abstract hasAssembleiaInicioVotacaoIniciada(assembleia: Assembleia);
  abstract hasAssembleiaDataExpirada(assembleia: Assembleia);
  abstract convertToValidDate(dataString: string): Date;
  abstract hasAssembleiaFimVotacaoFinalizada(assembleia: Assembleia);
  abstract isAssembleiaFinalizada(assembleia: Assembleia);
  abstract isAssembleiaOnline(assembleia: Assembleia);
  abstract get isAdmin();
}